import React from 'react';
import { Link } from 'react-router-dom';
import { MetaHead } from '../components/MetaHead';
import { SCRAPED_PAGES, COMPANY_INFO, COMMON_CONTACT_CALLOUT } from '../data/scrapedData';

export function PracticalInfoPage() {
  const r = SCRAPED_PAGES.regler;

  return (
    <>
      <MetaHead title={SCRAPED_PAGES.praktiskeOplysninger.title} description={SCRAPED_PAGES.praktiskeOplysninger.metaDescription} />

      <section className="bg-[#1C1C1E] text-white py-14 sm:py-18">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-xs uppercase tracking-widest font-semibold text-[#3885B8] block mb-2">
            Praktisk
          </span>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-white mb-3">
            Praktiske oplysninger & Husregler
          </h1>
          <p className="text-base sm:text-lg text-white/90 max-w-3xl leading-relaxed">
            {SCRAPED_PAGES.praktiskeOplysninger.intro}
          </p>
        </div>
      </section>

      <section className="py-16 bg-[#F8FAFC]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          
          {/* Main 2 Rules */}
          <div className="bg-white p-8 rounded-2xl border-l-4 border-red-500 shadow-xs space-y-3">
            <span className="text-xs uppercase tracking-wider font-bold text-red-600 block">
              Primære Husregler
            </span>
            <p className="text-lg font-bold text-[#1C1C1E]">
              {r.mainRules}
            </p>
          </div>

          {/* Rules List */}
          <div className="bg-white p-8 rounded-2xl border border-[#1C1C1E]/10 shadow-xs space-y-4">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1C1C1E] tracking-tight mb-4">
              Daglige husregler og omgangstone
            </h2>
            <ul className="space-y-3">
              {r.rulesList.map((rule, idx) => (
                <li key={idx} className="flex items-start gap-3 text-sm text-[#1C1C1E]/80 leading-relaxed">
                  <i className="fa-solid fa-circle-check text-[#3885B8] mt-1 text-base" aria-hidden="true" />
                  <span>{rule}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Indbo & Forsikring */}
          <div className="bg-white p-8 rounded-2xl border border-[#1C1C1E]/10 shadow-xs space-y-3">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1C1C1E] tracking-tight mb-4">
              Indboforsikring
            </h2>
            <p className="text-sm text-[#1C1C1E]/80 leading-relaxed">
              {r.insuranceNote}
            </p>
          </div>

          {/* Kærester / Parforhold */}
          <div className="bg-white p-8 rounded-2xl border border-[#1C1C1E]/10 shadow-xs space-y-3">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1C1C1E] tracking-tight mb-4">
              Regler for parforhold
            </h2>
            <p className="text-sm text-[#1C1C1E]/80 leading-relaxed">
              {r.relationshipsNote}
            </p>
          </div>

          {/* Ture ud af huset */}
          <div className="bg-white p-8 rounded-2xl border border-[#1C1C1E]/10 shadow-xs space-y-4">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1C1C1E] tracking-tight mb-4">
              Ansøgning om ture ud af huset
            </h2>
            <p className="text-sm text-[#1C1C1E]/80 leading-relaxed">
              {r.tripsNote}
            </p>

            <div className="pt-2 space-y-2">
              <span className="text-xs font-bold text-[#1C1C1E] uppercase tracking-wider block">
                Kriterier for udegang:
              </span>
              {r.tripMilestones.map((ms, idx) => (
                <div key={idx} className="p-3.5 bg-[#F8FAFC] rounded-xl border border-[#1C1C1E]/10 text-xs sm:text-sm font-medium text-[#1C1C1E] flex items-center gap-2">
                  <i className="fa-solid fa-calendar-check text-[#3885B8]" aria-hidden="true" />
                  <span>{ms}</span>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

      {/* Callout */}
      <section className="py-12 bg-white border-t border-[#1C1C1E]/10">
        <div className="max-w-7xl mx-auto px-4 text-center space-y-4">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1C1C1E] tracking-tight mb-4">{COMMON_CONTACT_CALLOUT.header}</h2>
          <p className="text-sm text-[#1C1C1E]/80 leading-relaxed">{COMMON_CONTACT_CALLOUT.p1}</p>
          <div className="pt-2 flex justify-center gap-4">
            <a href={COMPANY_INFO.phoneTel} className="bg-[#3885B8] hover:bg-[#2A6E9B] text-white px-5 py-2.5 rounded-full font-semibold text-sm whitespace-nowrap">
              Ring {COMPANY_INFO.phone}
            </a>
            <a href={COMPANY_INFO.emailMailto} className="border border-[#3885B8] text-[#3885B8] hover:bg-[#3885B8]/10 px-5 py-2.5 rounded-full font-semibold text-sm whitespace-nowrap">
              Skriv til os
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
